import React, { Component } from "react";
import { Modal, Row, Col } from "antd";
import "./Modal.css";
import Reparcelamento1 from '../imagens/LancReparcelamento/Reparcelamento1.png';
import Reparcelamento2 from '../imagens/LancReparcelamento/Reparcelamento2.png';
import Reparcelamento3 from '../imagens/LancReparcelamento/Reparcelamento3.png';
import Reparcelamento4 from '../imagens/LancReparcelamento/Reparcelamento4.png';
import Reparcelamento5 from '../imagens/LancReparcelamento/Reparcelamento5.png';
import Reparcelamento6 from '../imagens/LancReparcelamento/Reparcelamento6.png';
import Reparcelamento7 from '../imagens/LancReparcelamento/Reparcelamento7.png';
import Reparcelamento8 from '../imagens/LancReparcelamento/Reparcelamento8.png';


export default class Reparcelamento extends Component {

    render() {

        const { isOpen, onClose } = this.props;

        return (
            <Modal
                title="Como utilizar o reparcelamento de Lançamentos Financeiros"
                className="modal"
                visible={isOpen}
                destroyOnClose
                onCancel={onClose}
                footer={null}
                width="50%"
                style={{ top: 10 }}
            >
                <Row>
                    <Col xs={24}>
                        <p>Para acessar o Reparcelamento de Lançamentos Financeiros siga o seguinte atalho:  </p>

                        <div className="image-wrapper">
                            <img className="img_smaller" src={Reparcelamento1} alt="Reparcelamento 1" />
                        </div>

                        <div className="gray_bar"></div>

                        <div className="image-wrapper">
                            <img src={Reparcelamento2} alt="Reparcelamento 2" />
                        </div>

                        <h3>Na tela de Reparcelamento Financeiro nós temos:</h3>
                        <ol>
                            <li>Filtros para buscar os lançamentos.</li>
                            <li>Tabela mostrando todas os lançamentos financeiros cadastrados.</li>
                            <li>Paginação da tabela de Lançamentos.</li>
                            <li>Botão para alterar as Parcelas do Lançamento Financeiro</li>
                        </ol>

                        <div className="gray_bar"></div>

                        <h3>Como alterar o Parcelamento de um lançamento</h3>
                        <p>
                            *Detalhe importante: Caso o gestor utilize o controle de caixa e tenha criado um caixa no dia do lançamento, não esqueça que o caixa daquele dia
                            precisa estar aberto para poder fazer alterações no lançamento.
                        </p>
                        <p>Para começar a alterar o parcelamento selecione o Lançamento Financeiro desejado e clique no botão de reparcelar</p>
                        <div className="image-wrapper">
                            <img src={Reparcelamento3} alt="Reparcelamento 3" />
                        </div>

                        <div className="image-wrapper">
                            <img src={Reparcelamento4} alt="Reparcelamento 4" />
                        </div>

                        <p>Dentro da tela de reparcelamento o gestor possui as opções de: </p>
                        <ol>
                            <li>Adicionar uma nova parcela.</li>
                            <li>Editar/Excluir uma parcela existente.</li>
                            <li>Alterar os dados principais do lançamento.</li>
                        </ol>
                        <p>
                            Caso o gestor queira alterar informações de uma parcela basta clicar no botão de Editar. Depois de fazer as alterações desejadas basta clicar em 
                            Salvar Parcela.
                        </p>
                        <div className="image-wrapper">
                            <img src={Reparcelamento7} alt="Reparcelamento 7" />
                        </div>
                        <p>
                            No reparcelamento, caso você fassa alterações onde o valor das parcelas difere do valor total do Lançamento, o sistema irá mostrar a diferença e
                            irá bloquear quando o gestor tentar salvar com a diferença.
                        </p>
                        <div className="image-wrapper">
                            <img src={Reparcelamento5} alt="Reparcelamento 5" />
                        </div>
                        <p>
                            Para adicionar uma Parcela nova basta clicar no botão "Adicionar". Caso o gestor adicionar uma nova parcela, não se esqueça da regra da diferença
                            do valor entre as parcelas e o valor total do lançamento. 
                        </p>
                        <div className="image-wrapper">
                            <img src={Reparcelamento6} alt="Reparcelamento 6" />
                        </div>  
                         <p>
                            Embora seja possível marcar a parcela como paga nessa tela de Reparcelamento, o ideal seria que o gestor fassa o pagamento da parcela pela tela de 
                            ficha financeira ou pela tela de contas a pagar/receber. 
                        </p>  
                        <div className="image-wrapper">
                            <img className="img_smaller" src={Reparcelamento8} alt="Reparcelamento 8" />
                        </div>                                                                   
                    </Col>
                </Row>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/tutoriais/LancReparcelamento.js